module.exports = __webpack_public_path__ + "img/mail.c75ee5d1.svg";